import { parseISO } from "date-fns";

export function parseDateOnly(value: string): Date {
    return parseISO(value.slice(0, 10));
}
